import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { HightScoreTab } from "./HighScoreTab";

export class HUD extends Phaser.GameObjects.Container {

    private scoreLabel: Phaser.GameObjects.Text;
    private openMatchesLabel: Phaser.GameObjects.Text;
    private remainingTilesLabel: Phaser.GameObjects.Text;
    private timerLabel: Phaser.GameObjects.Text;
    private highScoreTab: HightScoreTab;
    private upperContainer: Phaser.GameObjects.Container;
    private shuffling: boolean;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scaleX = GameVars.scaleX;

        this.shuffling = false;

        this.upperContainer = new Phaser.GameObjects.Container(scene);
        this.add(this.upperContainer);

        const stripe = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "gui_frame");
        stripe.setOrigin(.5, 0);
        this.upperContainer.add(stripe);

        if (GameVars.isMobile) {

            const aspectRatio = window.innerWidth / window.innerHeight;

            if (aspectRatio > 2.2) {
                stripe.scaleX = 1.25;
            }
        }

        const background = new Phaser.GameObjects.Image(scene, 0, 42, "texture_atlas_1", "hud");
        this.upperContainer.add(background);   

        if (GameConstants.SHOW_SCORE) {
            this.scoreLabel = new Phaser.GameObjects.Text(this.scene, -360, background.y, "0", {fontFamily: "OpenSans-CondLight", fontSize: "26px", color: "#A17A65"});
            this.scoreLabel.setOrigin(.5);
            this.upperContainer.add(this.scoreLabel);
        } else {
            this.scoreLabel = null;
        }

        this.openMatchesLabel = new Phaser.GameObjects.Text(this.scene, 175, background.y + 2, gameText.OPEN_MATCHES[lan] + ":10", {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        this.openMatchesLabel.setOrigin(0, .5);
        this.upperContainer.add(this.openMatchesLabel);

        if (this.openMatchesLabel.width > 212) {
            this.openMatchesLabel.setScale(212 / this.openMatchesLabel.width);
        }

        this.remainingTilesLabel = new Phaser.GameObjects.Text(this.scene, -30, background.y + 2, gameText.REMAINING_TILES[lan] + ": 144", {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        this.remainingTilesLabel.setOrigin(.5);
        this.upperContainer.add(this.remainingTilesLabel);

        if (this.remainingTilesLabel.width > 242) {
            this.remainingTilesLabel.setScale(242 / this.remainingTilesLabel.width);
        }

        this.timerLabel = new Phaser.GameObjects.Text(this.scene, -340, background.y + 2, gameText.TIME[lan] + " 0:00", {fontFamily: "OpenSans-CondLight", fontSize: "30px", color: "#A17A65"});
        this.timerLabel.setOrigin(0, .5);
        this.upperContainer.add(this.timerLabel);

        if (this.timerLabel.width > 100) {
            this.timerLabel.setScale(100 / this.timerLabel.width);
        }
    }

    public update(): void {

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.timerLabel.text = gameText.TIME[lan] + " " + GameVars.formatTime(Math.floor(GameVars.mahjongEngine.boardData.seconds));
    }

    public startGame(): void {

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const n = GameVars.mahjongEngine.getPotentialPairsCount();

        this.openMatchesLabel.setText(gameText.OPEN_MATCHES[lan] + ":" + n);
        this.remainingTilesLabel.setText(gameText.REMAINING_TILES[lan] + ":" + GameVars.mahjongEngine.boardData.n);

        if (!GameVars.levelReset) {

            this.upperContainer.y = -125;

            this.scene.tweens.add({
                targets: this.upperContainer,
                y: 0,
                duration: 1000,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }

        if (GameVars.bestTime !== null && GameVars.bestTime > 0) {

            this.highScoreTab = new HightScoreTab(this.scene);
            this.add(this.highScoreTab);

            this.highScoreTab.startGame();
        }
    }

    public undo (): void {

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const n = GameVars.mahjongEngine.getPotentialPairsCount();
        this.openMatchesLabel.setText(gameText.OPEN_MATCHES[lan] + ":" + n);

        this.remainingTilesLabel.setText(gameText.REMAINING_TILES[lan] + ":" + GameVars.mahjongEngine.boardData.n);
    }

    public onGamePausedResumed(): void {

        if (this.highScoreTab) {
            this.highScoreTab.onGamePausedResumed();
        }

        if (GameVars.paused) {

            this.scene.tweens.add({
                targets: this.timerLabel,
                alpha: .25,
                duration: 450,
                ease: Phaser.Math.Easing.Cubic.Out,
                repeat: -1,
                yoyo: true
            });

        } else {

            this.scene.tweens.killTweensOf(this.timerLabel);
            this.timerLabel.alpha = 1;
        }
    }

    public onMatch(scoreData: {score: number, deltaSore: number, combo: number}): void {

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.scene.time.delayedCall(750, function(): void {

            if (GameConstants.SHOW_SCORE) {
                this.scoreLabel.setText(GameVars.formatNumber(scoreData.score));
            }

            if (!this.shuffling) {
                const n = GameVars.mahjongEngine.getPotentialPairsCount();
                this.openMatchesLabel.setText(gameText.OPEN_MATCHES[lan] + ":" + n);
            }
            
            this.remainingTilesLabel.setText(gameText.REMAINING_TILES[lan] + ":" + GameVars.mahjongEngine.boardData.n);

        }, [], this);
    }

    public onShuffle(): void {

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.shuffling = true;

        this.openMatchesLabel.setText(gameText.OPEN_MATCHES[lan] + ":0");

        this.scene.time.delayedCall(3000, function(): void {

            this.shuffling = false;

            const n = GameVars.mahjongEngine.getPotentialPairsCount();

            this.openMatchesLabel.setText(gameText.OPEN_MATCHES[lan] + ":" + n);
            this.remainingTilesLabel.setText(gameText.REMAINING_TILES[lan] + ":" + GameVars.mahjongEngine.boardData.n);

        }, [], this);
    }
}
